import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6a3 3 0 0 1 3 3v9a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2a3 3 0 0 0 -6 0v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-9a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconBuildingBridge2Filled = createReactComponent('filled', 'building-bridge-2-filled', 'BuildingBridge2Filled', __iconNode);

export default IconBuildingBridge2Filled;